import {Component, HostListener, OnDestroy, OnInit} from '@angular/core';
import {UrlService} from '../../services/url.service';
import {SettingsAmenitiesService} from '../../services/settings-amenities.service';
import {flatMap, takeUntil, tap} from 'rxjs/operators';

@Component({
    templateUrl: 'settings-amenities.component.html'
})
export class SettingsAmenitiesComponent implements OnInit, OnDestroy {
    constructor(public settingsAmenitiesService: SettingsAmenitiesService,
                public urlService: UrlService) {
    }

    ngOnInit() {
        this.settingsAmenitiesService.getUserRoles();
        this.settingsAmenitiesService.getBuildings();
        this.settingsAmenitiesService.getOccupancyTypes();
        this.settingsAmenitiesService.getGroups();
        this.settingsAmenitiesService.firstTimeLoading = true;

        this.urlService.onUrlChange
            .pipe(
                tap(
                    () => {
                        this.settingsAmenitiesService.tabId = this.urlService.queryParams['tab'];
                        this.settingsAmenitiesService.showDetailedView = false;
                        this.settingsAmenitiesService.selectedItemData = null;
                    }
                ),
                flatMap(
                    () => this.settingsAmenitiesService.getDataByQueryParams(true).pipe(takeUntil(this.urlService.instantOnUrlChange))
                )
            )
            .subscribe();
        this.urlService.setQueryParams('allSettingsAmenities');
    }

    ngOnDestroy() {
        this.removeAllObservers();
        this.settingsAmenitiesService.resetData();
        this.urlService.resetQueryParams();
    }

    removeAllObservers() {
        this.urlService.onUrlChange.observers = [];
    }

    @HostListener('window:resize', ['$event'])
    onResize() {
        this.settingsAmenitiesService.emptyRowService.fillEmptyRow();
    }
}





// WEBPACK FOOTER //
// /app/src/app/views/settings-amenities/settings-amenities.component.ts